import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { fetchVideos, fetchCategories, deleteVideo, deleteCategory, clearMessages } from '../../../redux/slices/admin/videoSlice';
import { exportClients } from '../../../redux/slices/admin/clientsSlice';
import VideosTable from './VideosTable';
import CategoriesTable from './CategoriesTable';
import iconPlus from '../../../images/icon-plus-symbol.svg';
import showAlert from '../../../components/common/showAlert';
import VideoModal from './VideoModal';
import CategoryModal from './CategoryModal';
import SearchField from '../../../components/common/SearchField';
import iconPrinter from '../../../images/icon-printer.svg';
import iconDownload from '../../../images/icon-download.svg';

const Videos = () => {
  const dispatch = useDispatch();  
  const [activeTab, setActiveTab] = useState('videos');
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    url: '',
    thumbnail: null,
  });

  useEffect(() => {
    dispatch(fetchVideos(1));
    dispatch(fetchCategories(1));
  }, [dispatch]);

  const successMessage = useSelector((state) => state.admin_videos?.successMessage);

   useEffect(() => {
    if (successMessage && successMessage != '') {   
      showAlert('success', successMessage);
      switch (activeTab) {
        case 'videos':
            setIsVideoModalOpen(false);
            break;
        case 'categories':
            setIsCategoryModalOpen(false); 
            break;
        default:            
      }
      dispatch(clearMessages());
    }
  }, [successMessage]);

  const handleTabChange = (tab) => {    
    var search_field_value = document.getElementById('searchField').value;
    if (search_field_value.length>0) {
      if (activeTab == 'videos') {
        dispatch(fetchVideos(1));
      }
      if (activeTab == 'categories') {
        dispatch(fetchCategories(1));
      }
    }
    setActiveTab(tab);
    closeModal();
  };

  const openCreateModal = (type) => {
    switch (type) {
      case 'video':
        setIsVideoModalOpen(true);
        break;
      case 'category':
        setIsCategoryModalOpen(true);
        break;
      default:
        break;
    }
    setIsEditMode(false);
    setFormData({
      name: '',
      description: '',
      url: '',
      thumbnail: null,
    });
  }; 

  const openEditModal = (item, type) => {
    setFormData(item);
    setIsEditMode(true);
    switch (type) {
      case 'video':
        setIsVideoModalOpen(true);
        break;
      case 'category':
        setIsCategoryModalOpen(true);
        break;
      default:
        break;
    }
  };

  const closeModal = () => {
    setIsVideoModalOpen(false);
    setIsCategoryModalOpen(false);
    setIsEditMode(false);
    setFormData({
      name: '',
      description: '',
      url: '',
      thumbnail: null,
    });
  };

  const handleSearch = (searchTerm, activeTab) => {
    if (activeTab == 'videos') {
      dispatch(fetchVideos({ page: 1, searchTerm:searchTerm }));
    }
    if (activeTab == 'categories') {
      dispatch(fetchCategories({ page: 1,searchTerm:searchTerm }));
    }
  }

  const handlePrint = () => { window.print(); }

  const handleDownloadExcel = (type) => {
    dispatch(exportClients(type));
  };

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab">
          <div className="col-md-12">
            <h1 className="title-page">Videos</h1>
          </div>
          <div className="col">
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'videos' ? 'active' : ''}`}
                  type="button"
                  role="tab"
                  onClick={() => handleTabChange('videos')}
                >
                  Videos
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'categories' ? 'active' : ''}`}
                  type="button"
                  role="tab"
                  onClick={() => handleTabChange('categories')}
                >
                  Categories
                </button>
              </li>
            </ul>
          </div>

         <div className="col-12 mt-4">
      <div className="tab-content">
        {activeTab === 'videos' && (
          <div className="tab-pane show active" role="tabpanel">
            <ul className="ul-btns-action">
              <li>
                <a>
                  <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                </a>
              </li>
              <li>
                <a onClick={()=>handleDownloadExcel('get_started_videos')}>
                  <img src={iconDownload} alt="Download" />
                </a>
              </li>
              <li>
                <a onClick={() => openCreateModal('video')} className="add-plus-icon">
                  <img src={iconPlus} alt="Add Video" />
                </a>
              </li>
            </ul>
            <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Videos..." />
            <VideosTable
              onEdit={(item) => openEditModal(item, 'video')}
              onDelete={(id) => dispatch(deleteVideo(id))}
              handlePageChange={(page) => dispatch(fetchVideos({ page }))}
            />
          </div>
        )}

        {activeTab === 'categories' && (
          <div className="tab-pane show active" role="tabpanel">
            <ul className="ul-btns-action">
              <li>
                <a>
                  <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                </a>
              </li>
              <li>
                <a onClick={()=>handleDownloadExcel('video_categories')}>
                  <img src={iconDownload} alt="Download" />
                </a>
              </li>
              <li>
                <a onClick={() => openCreateModal('category')} className="add-plus-icon">
                  <img src={iconPlus} alt="Add Category" />
                </a>
              </li>
            </ul>
            <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Categories..." />
            <CategoriesTable
              onEdit={(item) => openEditModal(item, 'category')}
              onDelete={(id) => dispatch(deleteCategory(id))}
              handlePageChange={(page) => dispatch(fetchCategories({ page }))}
            />
          </div>
        )}
      </div>
    </div>
        </div>
        
      {isVideoModalOpen && <VideoModal isOpen={isVideoModalOpen} closeModal={closeModal} initialData={formData} isEditMode={isEditMode} />}
      {isCategoryModalOpen && <CategoryModal isOpen={isCategoryModalOpen} closeModal={closeModal}  initialData={formData} isEditMode={isEditMode} />}

      </div>
    </Layout>
  );
};

export default Videos;